/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_Player_CountInputs */



/**
* | output |
* | --- |
* | "Finals player count mismatch" |
*
* @param {Err_Tournament_Finals_Player_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_player_count = /** @type {((inputs?: Err_Tournament_Finals_Player_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_Player_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de joueurs incorrect pour la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de jugadores incorrecto para las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de jogadores incorreto para as finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di giocatori non corretto per le finali")
	return /** @type {LocalizedString} */ ("Finals player count mismatch")
});